import { render, staticRenderFns } from "./RulesKanban.vue?vue&type=template&id=657eecf7&scoped=true&"
import script from "./RulesKanban.vue?vue&type=script&lang=js&"
export * from "./RulesKanban.vue?vue&type=script&lang=js&"
import style0 from "./RulesKanban.vue?vue&type=style&index=0&id=657eecf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657eecf7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
